import { render, staticRenderFns } from "./PermissionsOrganizationsForm.vue?vue&type=template&id=530abe76&scoped=true&"
import script from "./PermissionsOrganizationsForm.vue?vue&type=script&lang=js&"
export * from "./PermissionsOrganizationsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530abe76",
  null
  
)

export default component.exports